<!-- Main Content Here -->
@if (user$ | async; as user) {
  <div class="main">
    <div class="basic-info">
      <div class="circle">{{ user.user.slice(0, 1) }}</div>
      <div class="flex flex-col">
        <span>{{ user.user }}</span>
        <span class="other-options">Basic info | favourites | temporary users</span>
      </div>
    </div>
    <mat-divider></mat-divider>
    <!-- Radio buttons to choose between different roles  -->
    <div class="roles">
      <mat-radio-group class="radio-group" aria-label="Select an option" [value]="user.role" (change)="onChange($event)">
        @for (role of roles$ | async; track role) {
          <mat-radio-button class="radio-button" [value]="role"> {{ role }}</mat-radio-button>
        }
      </mat-radio-group>
    </div>
    <mat-divider></mat-divider>
    <!-- last login and other data -->
    <div class="other-info">
      <div class="text-[14px]">{{ 'Last login' | translate }}: {{ user?.lastLogin }}</div>
      <!-- <div class="my-2 cursor-pointer text-[14px] font-bold text-green-700" (click)="logout()">Log out</div> -->
    </div>
  </div>
}
